import React, { useState } from 'react'

const getCardType = (number) => {
  const bin = number.replace(/\s+/g, '').slice(0, 6)
  if (/^4/.test(bin)) return 'Visa'
  if (/^5[1-5]/.test(bin) || /^2(?:2[2-9]|[3-6]\d|7[01])/.test(bin)) return 'Mastercard'
  if (/^3[47]/.test(bin)) return 'American Express'
  if (/^6(?:011|5|4[4-9])/.test(bin)) return 'Discover'
  if (/^(6334|6767|6706|6709|6333)/.test(bin)) return 'Interac'
  return 'Unknown'
}

const cardLogo = {
  Visa: '/assets/visa.png',
  Mastercard: '/assets/mastercard.png',
  'American Express': '/assets/american-express.png',
  Discover: '/assets/discover-card.png',
  Interac: '/assets/interac-card.png',
  Unknown: '/assets/unknown-card.png'
}

const RegisterCard = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    cardNumber: '',
    expiry: '',
    cvv: ''
  })
  const [cardType, setCardType] = useState(null)
  const [error, setError] = useState(null)
  const [successMsg, setSuccessMsg] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    let formatted = value
    if (name === 'cardNumber') {
      formatted = value.replace(/\D/g, '').replace(/(.{4})/g, '$1 ').trim()
      setCardType(getCardType(formatted))
    }
    setFormData(prev => ({ ...prev, [name]: formatted }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setError(null)
    setSuccessMsg(null)
    const { name, email, address, cardNumber, expiry, cvv } = formData
    if (!name || !email || !address || cardNumber.replace(/\s/g, '').length < 16 || !expiry || cvv.length < 3) {
      setError('Please fill in all fields correctly.')
      return
    }
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
      setSuccessMsg(`Saved ${cardType || 'Card'} ending in ${cardNumber.slice(-4)}`)
    }, 1000)
  }

  return (
    <div className="bg-black text-white min-h-screen flex items-center justify-center py-20 px-4">
      <div className="bg-gray-900 rounded-2xl shadow-xl max-w-md w-full p-8">
        <h1 className="text-2xl font-bold mb-6 text-center">Register Your Card</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          {['name','email','address'].map(field => (
            <div key={field}>
              <label htmlFor={field} className="block text-sm font-medium capitalize">
                {field.replace(/([A-Z])/g, ' $1')}
              </label>
              <input
                type={field === 'email' ? 'email' : 'text'}
                id={field}
                name={field}
                value={formData[field]}
                onChange={handleChange}
                required
                className="mt-1 block w-full px-4 py-2 bg-black text-white border border-purple-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
              />
            </div>
          ))}

          <div>
            <label htmlFor="cardNumber" className="block text-sm font-medium mb-1">Card Number</label>
            <div className="relative bg-black px-3 py-2 border border-purple-500 rounded-lg">
              <input
                type="text"
                id="cardNumber"
                name="cardNumber"
                placeholder="1234 5678 9012 3456"
                value={formData.cardNumber}
                onChange={handleChange}
                maxLength={19}
                required
                className="w-full bg-transparent text-white placeholder-gray-500 outline-none"
              />
              {cardType && (
                <img
                  src={cardLogo[cardType]}
                  alt={cardType}
                  className="absolute top-2 right-3 w-8 h-auto"
                />
              )}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="expiry" className="block text-sm font-medium mb-1">Expiry (MM/YY)</label>
              <input
                type="text"
                id="expiry"
                name="expiry"
                placeholder="MM/YY"
                value={formData.expiry}
                onChange={handleChange}
                maxLength={5}
                required
                className="mt-1 block w-full px-4 py-2 bg-black text-white border border-purple-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
              />
            </div>
            <div>
              <label htmlFor="cvv" className="block text-sm font-medium mb-1">CVV</label>
              <input
                type="password"
                id="cvv"
                name="cvv"
                placeholder="123"
                value={formData.cvv}
                onChange={handleChange}
                maxLength={4}
                required
                className="mt-1 block w-full px-4 py-2 bg-black text-white border border-purple-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
              />
            </div>
          </div>

          {error && <div className="text-red-500 text-sm">{error}</div>}
          {successMsg && <div className="text-green-400 text-sm">{successMsg}</div>}

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-3 rounded-lg font-medium transition focus:outline-none text-white ${loading ? 'bg-gray-600' : 'bg-purple-600 hover:bg-purple-700'}`}
          >
            {loading ? 'Saving...' : 'Save Card'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default RegisterCard

